/**
 * Why an NGP report store-context sync was triggered.
 */
export enum NgpReportStoreSyncReason {
  PageEnter = 'page-enter',
  StoreSelected = 'store-selected',
  StoresLoaded = 'stores-loaded',
}
